var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('amplify-authenticator',[_c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"alt":"Cluster","src":require("./assets/logo.svg")}}),_c('amplify-sign-out')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }